<template>
    <div v-loading="dataLoading">
        <el-alert type="warning" :closable="false">
            <div slot="title">
                我是一个怀旧的人！想回归熟悉的操作与界面。
                <router-link to="/workbench/dashboard1" class="color-danger">切换旧版<i class="el-icon-right"></i></router-link>
            </div>
        </el-alert>
        <div class="page-tab-box MT20">
            <el-radio-group v-model="timeInterval" class="MR20" @change="timeIntervalChange">
                <el-radio-button v-for="item in interval" :key="item.timeInterval" :label="item.timeInterval">{{item.name}}</el-radio-button>
            </el-radio-group>
            <el-date-picker v-model="daterange" type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="daterangeChange" :clearable="false" unlink-panels :picker-options="pickerOptions">
            </el-date-picker>
        </div>
        <el-tabs v-if="daterange && daterange.length > 0" type="border-card" class="MT20" v-model="tabValue">
            <el-tab-pane name="1">
                <span slot="label"><i class="el-icon-mic"></i> 演出</span>
                <template v-if="tabValue == '1'">
                    <activity-sales v-if="$utils.have('/dashboard/activitySales2')" :daterange="daterange"></activity-sales>
                    <activity-rank v-if="$utils.have('/dashboard/salesRank2')" :daterange="daterange" class="MT20"></activity-rank>
                </template>    
            </el-tab-pane>
            <el-tab-pane name="2">
                <span slot="label"><i class="el-icon-user"></i> 用户</span>
                <template v-if="tabValue == '2'">
                    <user-data :daterange="daterange"></user-data>
                    <user-rank :daterange="daterange" class="MT20"></user-rank>
                </template>
            </el-tab-pane>
            <el-tab-pane name="3">
                <span slot="label"><i class="el-icon-goods"></i> 周边</span>
                <template v-if="tabValue == '3'">
                    <goods-sales :daterange="daterange"></goods-sales>
                    <goods-rank :daterange="daterange" class="MT20"></goods-rank>
                </template>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import ActivitySales from './components/activity-sales.vue';
import ActivityRank from './components/activity-rank.vue';

import UserData from './components/user-data.vue';
import UserRank from './components/user-rank.vue';

import GoodsSales from './components/goods-sales.vue';
import GoodsRank from './components/goods-rank.vue';

export default {
    components: {
        ActivitySales,
        ActivityRank,
        UserData,
        UserRank,
        GoodsSales,
        GoodsRank
    },
    data(){
        return{
            dataLoading: false,
            timeInterval: -2,
            interval: [],
            // intervalData: null,
            daterange: [],
            pickerMinDate1: "",//第一次选中的时间
            pickerOptions: {
                onPick: obj => {
                    this.pickerMinDate1 = new Date(obj.minDate).getTime();
                },
                disabledDate: (time) => {
                    if (this.pickerMinDate1 && time.getTime() <= Date.now()) {
                        const day1 = 730 * 24 * 3600 * 1000;
                        let maxTime = this.pickerMinDate1 + day1;
                        let minTime = this.pickerMinDate1 - day1;
                        return time.getTime() > maxTime || time.getTime() < minTime;
                    }else{
                        return time.getTime() > Date.now();
                    }
                }
            },
            tabValue: "1"
        }
    },
    
    created(){
        this.getInterval();       
    },
    methods: {
        //获取时间间隔
        getInterval(){
            // this.dataLoading = true
			if(!this.$utils.have('/dashboard/interval')){				
				return;
			}else{
				this.$request({
					url: "/dashboard/interval",
					method: "POST",
				})
					.then((res) => {
						const { state, msg, result } = res.data;
						if (state == 1 && result) {
							this.interval = result.filter(v => v.timeInterval < -1);

                            this.interval.map( v => {
                                if(v.timeInterval == -2 ){
                                    v.name = '今年'
                                }else if(v.timeInterval == -6){
                                    v.name = '去年'
                                }else{
                                    v.name = this.$utils.formatDate(v.startTime, 'yyyy年MM月')
                                }
                            })
                            this.interval.sort( (a,b) => {return a.timeInterval > b.timeInterval ? -1 : 1} )
							// this.intervalData = this.interval.find(v => v.timeInterval == this.timeInterval);
                            this.timeIntervalChange(this.timeInterval);
                        } else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
			}
        },
        //快捷选择时间段
        timeIntervalChange(e){
            const _interval =   this.interval.find(v => v.timeInterval == e);
            this.daterange = [_interval.startTime, _interval.endTime];
        },
        //选择自定义时间段
        daterangeChange(e){
            this.timeInterval = "";
        }
    }
}
</script>

<style lang="scss" scoped>
.page-tab-box{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
::v-deep .group-head{
    display: flex;
    align-items: center;
    .title{
        font-size: 16px;
    }
}

::v-deep .rank-box{
    .el-card{
        // background: rgba(239, 232, 207, 40%);
        // border:0;
        .el-card__header{
            // background: rgba(239, 232, 207, 90%);
            // border: 0;
            padding: 12px 20px;
            > div{
                display: flex;
                justify-content: space-between;
                font-size: 13px;
                font-weight: 700;
                a{
                    font-size: 12px;
                }
            }
        }
    }
    .rank{
        height: 380px;
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        // align-content: center;
        .item{
            display: flex;
            align-items: center;
            margin: 12px 0;
            .logo{
                margin-right: 10px;
                width: 32px;
                .image-slot{
                    background: none;
                    font-size: 36px;
                    &.color-danger{
                        color: $--color-danger;
                    }
                }
            }
            .info{
                // flex: 1;
                max-width: calc(100% - 50px);
                .name{
                    font-size: 14px;
                }
                .amount{
                    font-size: 12px;
                    color: #666;
                }
            }
            .num{
                width: 32px;
                height: 32px;
                line-height: 32px;
                border-radius: 50%;
                background-color: #ededed;
                text-align: center;
                margin-right: 10px;
                font-size: 15px;
                font-weight: 700;
                &.top-num-0{
                    background-color: $--color-danger;
                    color: #fff;
                }
                &.top-num-1{
                    background-color: $--color-warning;
                    color: #fff;
                }
                &.top-num-2{
                    background-color: $--color-info;
                    color: #fff;
                }
            }
        }
    }
}

</style>